// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".report-info[data-v-7e1ef0d8]{padding:0 20px 20px}.report-info .grey-box[data-v-7e1ef0d8]{background:#f9f9f9}.report-info .grey-box-mar+.grey-box[data-v-7e1ef0d8]{margin-top:16px}.report-info .grey-box .h2-title[data-v-7e1ef0d8],.report-info .grey-box .h2-title-border[data-v-7e1ef0d8]{padding:16px 20px;font-size:16px;font-weight:500;color:#333;line-height:20px;border-bottom:1px solid #ddd}", ""]);
// Exports
module.exports = exports;
